import { EntitySectionArea as Component } from './component';
import Connector from './connector';
import { ConnectorProps } from './EntitySectionArea.proptype';

export interface EntitySectionAreaProps extends Omit<ConnectorProps, 'component'> {}

export const EntitySectionArea = (props: EntitySectionAreaProps) => <Connector {...props} component={Component} />;
